import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import { ReactElement } from "react";
import { UI_ITONumericInput } from "../../../UI_ITO/UI_ITONumericInput/UI_ITONumericInput";
import { IFilterApplicationForm } from "../../../interfaces/Application/FilterFrame/IFilterApplicationForm";
import { IFilterFrameProps } from "../../../interfaces/props/IFilterFrameProps";

import classes from "./FilterFrame.module.css";
import { UP_DATE_APPLICATIONS_ALL } from "../../../store/slice/applicationsSlice/applicationsSlice";
import { useAppDispatch } from "../../../store/reduxHooks";

/**
 * Компонент формы фильтрации заявок.
 *
 * @param {IFilterFrameProps} props - Свойства компонента.
 * @param {Function} props.onChangeForm - Колбэк, вызываемый при изменении формы.
 * @param {Function} props.onResetForm - Колбэк, вызываемый при сбросе формы.
 */
export function FilterFrame(props: IFilterFrameProps): ReactElement {
  const { onChangeForm, onResetForm } = props;
  const [form] = useForm<IFilterApplicationForm>();
  const dispatch = useAppDispatch();

  return (
    <div className={classes.banksWrapper}>
      <Form<IFilterApplicationForm>
        className={classes.form}
        form={form}
        autoComplete="off"
        name="filter_applications"
        onFieldsChange={() => {
          const values = form.getFieldsValue();
          dispatch(UP_DATE_APPLICATIONS_ALL({data: [], last_page: 1}));

          if (onChangeForm) onChangeForm(values);
        }}
      >
        <Form.Item name="purchase_number" noStyle={true}>
          <UI_ITONumericInput
            name="purchase_number"
            className={classes.searchNumber}
            placeholder="Номер закупки"
            suffix={<SearchOutlined className={classes.formIcon} />}
            allowClear
          />
        </Form.Item>

        <Form.Item name="application_id" noStyle={true}>
          <UI_ITONumericInput
            name="application_id"
            className={classes.searchNumber}
            placeholder="Номер заявки"
            suffix={<SearchOutlined className={classes.formIcon} />}
            allowClear
          />
        </Form.Item>

        <Form.Item name="organization_inn" noStyle={true}>
          <UI_ITONumericInput
            name="application_id"
            className={classes.searchNumber}
            placeholder="ИНН"
            suffix={<SearchOutlined className={classes.formIcon} />}
            allowClear
          />
        </Form.Item>

        <Button
          className={classes.buttonReset}
          type="primary"
          onClick={(e) => {
            form.resetFields();

            if (onResetForm) {
              onResetForm();
            }
          }}
        >
          Сбросить фильтр
          <CloseOutlined className={classes.formIcon} />
        </Button>
      </Form>
    </div>
  );
}
